/** Collision-resistant id that sorts roughly by creation time. */
export function newId(): string {
  const time = Date.now().toString(36);
  const random =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().slice(0, 8)
      : Math.random().toString(36).slice(2, 10);
  return `${time}-${random}`;
}
